const CustomizationModule = () => import('@/modules/CustomizationModule')

export default [
	{
		component: CustomizationModule,
		name: 'customization',
		path: 'pimpmyfirm'
	}
]
